import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  UiBoletoDirective, UiTributoDirective, UiCpfDirective,
  UiCnpjDirective, UiCartaoDirective, UiContaBancariaNumeroDigitoDirective,
  UiNumerosDirective, UiMoedaDirective, DataDirective, UiPontosDirective,
  UiEnterDirective
} from 'app/resources/diretives';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    UiBoletoDirective,
    UiTributoDirective,
    UiCpfDirective,
    UiCnpjDirective,
    UiCartaoDirective,
    UiContaBancariaNumeroDigitoDirective,
    UiNumerosDirective,
    UiMoedaDirective,
    DataDirective,
    UiPontosDirective,
    UiEnterDirective
  ],
  exports: [
    UiBoletoDirective,
    UiTributoDirective,
    UiCpfDirective,
    UiCnpjDirective,
    UiCartaoDirective,
    UiContaBancariaNumeroDigitoDirective,
    UiNumerosDirective,
    UiMoedaDirective,
    DataDirective,
    UiPontosDirective,
    UiEnterDirective
  ]
})
export class DiretivesModule { }



// WEBPACK FOOTER //
// ./src/app/resources/diretives/diretives.module.ts